const footerEN = {
	links: {
		about: "About Us",
		privacy: "Privacy Policy",
		terms: "Terms of Service",
		contact: "Contact",
		refundPolicy: "Refund Policy"
	},
	apps: {
		appStoreAria: "Download on the App Store",
	googlePlayAria: "Get it on Google Play",
	},
	languageSwitch: "Español",
};

export default footerEN;